import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0","key":"svg-0"}],["path",{"d":"M13.02 21.206a2 2 0 0 1 -2.433 -.306l-4.244 -4.243a8 8 0 1 1 13.607 -6.555","key":"svg-1"}],["path",{"d":"M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5","key":"svg-2"}],["path",{"d":"M19 21v1m0 -8v1","key":"svg-3"}]]

const IconMapPinDollar = createReactComponent('outline', 'map-pin-dollar', 'MapPinDollar', __iconNode);

export default IconMapPinDollar;